import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view.
export const Reveal = ({ children, delay = 0, y = 28, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for big headlines.
export const MaskLines = ({ lines, className = "", start = 0.1, stagger = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: start + i * stagger }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const EASE_OUT = EASE;
